import { render, staticRenderFns } from "./EditOneOffCampaign.vue?vue&type=template&id=4858d242&scoped=true&"
import script from "./EditOneOffCampaign.vue?vue&type=script&lang=js&"
export * from "./EditOneOffCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EditOneOffCampaign.vue?vue&type=style&index=0&id=4858d242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858d242",
  null
  
)

export default component.exports